import { Trans, useTranslation } from 'react-i18next';
import { CSSProperties } from 'react';

import {
  containerStyles,
  headerTextStyles,
  textStyles
} from '@/components/Discovery/Card/placeholders/styles.ts';
import FlaskShape from '@/components/common/svg/shapes/FlaskShape.tsx';
import SmallStarsShape from '@/components/common/svg/shapes/SmallStarsShape.tsx';
import LottieAnimation from '@/animations/LottieAnimation.tsx';
import splashFoam from '@/components/common/svg/assets/splash_foam.json';
import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import VerifiedBadgeShape from '@/components/common/svg/shapes/VerifiedBadgeShape.tsx';
import { helpers } from '@/helpers.ts';
import FallingStarShape from '@/components/common/svg/shapes/FallingStarShape.tsx';

export const PendingVerification = () => {
  const { t } = useTranslation();

  return (
    <div style={containerStyles}>
      <div style={outerCircleContainer}>
        <div style={outerCircle} />
        <div style={innerCircle} />
        <div style={animationContainer}>
          <LottieAnimation
            width={46}
            height={46}
            speed={0.7}
            shouldAnimate={true}
            loop={true}
            animationData={splashFoam}
          />
        </div>

        <FlaskShape width={110} height={110} style={{ zIndex: 3 }} />

        <div style={{ position: 'absolute', top: -15, left: -35 }}>
          <FallingStarShape height={40} width={40} />
        </div>
        <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
          <SmallStarsShape height={30} width={30} />
        </div>
      </div>

      <div style={headerStyles}>
        <Trans
          i18nKey="discovery.card.placeholder.pendingVerification.header"
          components={{ br: <br /> }}
        />
      </div>

      <p style={paragraphStyles}>
        <Trans
          i18nKey="discovery.card.placeholder.pendingVerification.text"
          components={{ br: <br /> }}
        />
      </p>

      <div
        style={bottomBlock}
        onClick={() =>
          window.open(
            helpers.getEnvVar(
              'VITE_NEWS_CHANNEL_DEEPLINK',
              'https://t.me/KyivDateNews'
            ),
            '_blank'
          )
        }
      >
        <div style={bottomBlockContent}>
          <span style={bottomBlockTextStyle}>
            KyivDate |&nbsp;
            {t('discovery.card.placeholder.pendingVerification.bottom_text')}
          </span>
          <VerifiedBadgeShape fillColor="#fff" width={20} height={20} />
          <ArrowRightShape width={10} height={10} fillColor="#fff" />
        </div>
      </div>
    </div>
  );
};

const outerCircleContainer: CSSProperties = {
  position: 'relative',
  marginBottom: '15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '164px',
  height: '164px'
};

const outerCircle: CSSProperties = {
  position: 'absolute',
  width: '164px',
  height: '164px',
  background: 'rgba(255, 255, 255, 0.03)',
  borderRadius: '50%',
  zIndex: 1
};

const innerCircle: CSSProperties = {
  position: 'absolute',
  width: '136px',
  height: '136px',
  background: 'rgba(255, 255, 255, 0.09)',
  borderRadius: '50%',
  zIndex: 2
};

const animationContainer: CSSProperties = {
  position: 'absolute',
  width: '110px',
  height: '110px',
  zIndex: 7,
  marginTop: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const headerStyles: CSSProperties = {
  ...headerTextStyles,
  fontSize: 21,
  fontWeight: 'bold'
};

const paragraphStyles: CSSProperties = {
  ...textStyles,
  color: '#fff',
  fontWeight: 500,
  lineHeight: 1.5,
  fontSize: 14
};

const bottomBlock: CSSProperties = {
  position: 'absolute',
  bottom: 15,
  left: 30,
  right: 30,
  height: 50,
  borderRadius: 8,
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 15px'
};

const bottomBlockContent: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5px',
  flex: 1,
  textAlign: 'center'
};

const bottomBlockTextStyle: CSSProperties = {
  fontSize: 15,
  fontWeight: 500,
  color: '#fff'
};